import Vue from 'vue';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import moment from 'moment'; //时间格式化
import http from '@/assets/common/http/http.js'; //全局请求封装
import common from '@/assets/common/http/common.js'; //全局请求封装
import userSercive from '@/assets/common/http/user.js'; //全局请求封装
import storage from '@/assets/common/storage/storage.js'; //本地存储
import popup from '@/assets/common/popup/popup.js'; //全局公共弹窗
import utils from '@/assets/common/utils/utils.js'; //全局公共方法
import request from "@/assets/common/request/request.js" //全局请求封装





Vue.use(ElementUI);

Vue.prototype.$storage = storage;
Vue.prototype.$moment = moment;
Vue.prototype.$userSercive = userSercive;
Vue.prototype.$http = http;
Vue.prototype.$common = common;
Vue.prototype.$popup = popup;
Vue.prototype.$utils = utils;
Vue.prototype.$request = request



export default ({});